
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":".2","transform":"matrix(-1 0 0 1 7.358 7.107)","fill":"#7ED321","r":"7.107"}}),_c('path',{attrs:{"d":"M50 7.107l-6.19 3.574V3.533L50 7.107zm-5.571.62H7.358V6.487h37.07v1.238z","fill":"#7ED321"}}),_c('circle',{attrs:{"r":"4.119","transform":"matrix(-1 0 0 1 7.358 7.107)","fill":"#7ED321","stroke":"#7ED321","stroke-width":"1.238"}})])
          )
        }
      }
    